import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { map } from "lodash";
import { Globe, Check } from "lucide-react";

//i18n
import i18n from "../../../i18n";

import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import languages from "../../../CommonData/languages";
import api from "../../../helpers/api";

import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { enUS } from 'date-fns/locale/en-US';
import { fr } from 'date-fns/locale/fr';
registerLocale('en', enUS)
registerLocale('fr', fr)
setDefaultLocale(i18n.language)

const LanguageDropdown = ({ t }) => {
  const [singlebtn, setSinglebtn] = useState(false);

  const changeLanguageAction = (lang) => {
    i18n.changeLanguage(lang);
    const user = JSON.parse(localStorage.getItem('authUser'));
    // Persist language preference to user profile
    api.put("user/update-language", { userId: user.id, language: lang }).catch((err) => {
      console.error("Failed to update language preference:", err);
    });

    setDefaultLocale(lang)
  };

  const languageOptions = ({
    en: {
      label: t('shared.english', 'English (Default)'),
    },
    fr: {
      label: t('shared.french', 'French'),
    },
  }) 

  return (
    <React.Fragment>
      <Dropdown
        isOpen={singlebtn}
        toggle={() => setSinglebtn(!singlebtn)}
        className="d-inline-block language-switch"
      >
        <DropdownToggle className="btn header-item" tag="button">
          <Globe className="align-middle" size={20} />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {map(Object.keys(languageOptions), (key) => (
            <DropdownItem
              key={key}
              onClick={() => changeLanguageAction(key)}
              className={`dropdown-item notify-item language d-flex align-items-center py-2`}
            >
              <Check
                size={16}
                className={`me-3 ${i18n.language === key ? "" : "invisible"}`}
                strokeWidth={2}
              />
              <span className="align-middle fs-6">{languageOptions[key].label}</span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

LanguageDropdown.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(LanguageDropdown);

